/* Wishlist Plus 收藏 / 取消收藏埋点 */
(function () {
  if (window.__geekoWishlistBound) return;
  window.__geekoWishlistBound = true;

  var DEBOUNCE_MS = 300;
  var lastClickKey = '';
  var lastClickAt = 0;
  var HEART_SELECTOR = '[data-wishlist], [data-wl-pdp-icon-manual], .wl-btn, .wl-coll-btn, [data-gridwllist]';
  var DELETE_BTN_SELECTOR = '.wl-card-delete-btn';
  var CONFIRM_YES_SELECTOR = '#wl-confirm-yes';
  var CONFIRM_DISMISS_SELECTOR = '#wl-confirm-cancel, #wl-confirm-close';
  var pendingRemove = null;

  function canPublish() {
    return (
      typeof Shopify !== 'undefined' &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === 'function'
    );
  }

  function getAttr(el, names) {
    for (var i = 0; i < names.length; i++) {
      var value = el.getAttribute(names[i]);
      if (value) return value;
    }
    return '';
  }

  function getSource(btn) {
    if (
      btn.closest('.wl-pdp-icon-custom-wrapper') ||
      btn.hasAttribute('data-wishlist') ||
      btn.hasAttribute('data-wl-pdp-icon-manual') ||
      btn.classList.contains('wl-btn')
    ) {
      return 'pdp';
    }
    return 'product_card';
  }

  function isDebounced(productId, variantId) {
    var now = Date.now();
    var clickKey = productId + ':' + variantId;
    if (clickKey === lastClickKey && now - lastClickAt < DEBOUNCE_MS) return true;
    lastClickKey = clickKey;
    lastClickAt = now;
    return false;
  }

  function publish(name, productId, variantId, source, customerId) {
    Shopify.analytics.publish(name, {
      product_id: Number(productId),
      variant_id: Number(variantId || 0),
      customer_id: customerId || '',
      source: source,
      page: window.location.pathname + window.location.search,
      timestamp: lastClickAt,
    });
  }

  function isRemoveConfirmDialog() {
    var title = document.getElementById('wl-confirm-title');
    var text = title ? (title.textContent || '') : '';
    return /remove/i.test(text);
  }

  function clearPendingRemove() {
    pendingRemove = null;
  }

  function onDeleteClick(deleteBtn) {
    var card = deleteBtn.closest('.wl-product-card');
    if (!card) return;

    var productId = getAttr(card, ['data-product-id']);
    if (!productId) {
      clearPendingRemove();
      return;
    }

    pendingRemove = {
      productId: productId,
      variantId: getAttr(card, ['data-variant-id']),
    };
  }

  function onConfirmRemove() {
    if (!pendingRemove || !isRemoveConfirmDialog() || !canPublish()) {
      clearPendingRemove();
      return;
    }

    var productId = pendingRemove.productId;
    var variantId = pendingRemove.variantId;
    clearPendingRemove();
    if (isDebounced(productId, variantId)) return;

    publish('geeko_remove_from_wishlist', productId, variantId, 'wishlist_page', '');
  }

  function onHeartClick(btn) {
    var productId = getAttr(btn, ['data-proID', 'data-proid']);
    if (!productId || !canPublish()) return;

    var variantId = getAttr(btn, ['data-varID', 'data-varid']);
    if (isDebounced(productId, variantId)) return;

    var added = btn.getAttribute('data-added') === 'true';
    var name = added ? 'geeko_remove_from_wishlist' : 'geeko_add_to_wishlist';
    publish(
      name,
      productId,
      variantId,
      getSource(btn),
      getAttr(btn, ['data-customer-id', 'data-customerid'])
    );
  }

  function onWishlistClick(e) {
    var deleteBtn = e.target.closest(DELETE_BTN_SELECTOR);
    if (deleteBtn) {
      onDeleteClick(deleteBtn);
      return;
    }

    if (e.target.closest(CONFIRM_YES_SELECTOR)) {
      onConfirmRemove();
      return;
    }

    if (e.target.closest(CONFIRM_DISMISS_SELECTOR)) {
      clearPendingRemove();
      return;
    }

    var btn = e.target.closest(HEART_SELECTOR);
    if (!btn) return;
    onHeartClick(btn);
  }

  // 捕获阶段：避免 Wishlist Plus stopPropagation 导致收不到
  document.addEventListener('click', onWishlistClick, true);
})();
